// tslint:disable: max-classes-per-file

export interface IIntradayAggregateResponse {
  date_time: string;
  volume: number;
  variation_percentage: number;
  open_price: number;
  close_price: number;
  min_price: number;
  max_price: number;
}

export interface IIntradayDigitalResponse {
  date: string;
  closePrice: number;
  openPrice: number;
  maxPrice: number;
  minPrice: number;
  percentageChange: number;
  volume: number;
}

export interface IIntradayAggregate {
  dateTime: string;
  volume: number;
  variationPercentage: number;
  openPrice: number;
  closePrice: number;
  minPrice: number;
  maxPrice: number;
}

export class IntradayAggregateViewModel implements IIntradayAggregate {
  static fromJSON(
    json: IIntradayAggregateResponse,
  ): IntradayAggregateViewModel {
    return new IntradayAggregateViewModel(
      json.date_time,
      json.volume,
      json.variation_percentage,
      json.open_price,
      json.close_price,
      json.min_price,
      json.max_price,
    );
  }

  static fromDigitalJSON(
    json: IIntradayDigitalResponse,
  ): IntradayAggregateViewModel {
    return new IntradayAggregateViewModel(
      json.date,
      json.volume,
      json.percentageChange,
      json.openPrice,
      json.closePrice,
      json.minPrice,
      json.maxPrice,
    );
  }

  toJSON(): IIntradayAggregateResponse {
    return Object.assign(
      {},
      {
        date_time: this.dateTime,
        volume: this.volume,
        variation_percentage: this.variationPercentage,
        open_price: this.openPrice,
        close_price: this.closePrice,
        min_price: this.minPrice,
        max_price: this.maxPrice,
      },
    );
  }

  constructor(
    public dateTime: string,
    public volume: number,
    public variationPercentage: number,
    public openPrice: number,
    public closePrice: number,
    public minPrice: number,
    public maxPrice: number,
  ) {}
}
